import { useNavigate } from 'react-router-dom';

import { showToastMessage } from 'enable-ui';
import { useFormik } from 'formik';

import type { Institution } from '../type';

import { getInputStatus, hasEmptyValues, isValidEmail } from 'helpers';
import { apiCall } from 'hooks/service';

import { ERROR_MESSAGE, SUCCESS_MESSAGE } from 'constants/message';
import { PATH } from 'constants/path';

import { defaultInstitution } from '../constant';

export const useInstitutionFormController = () => {
  const navigationTo = useNavigate();

  const formik = useFormik({
    initialValues: defaultInstitution,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      const result: Institution = await apiCall({
        url: `/institutions`,
        method: 'POST',
        data: {
          code: values.code,
          name: values.name,
          email: values.email,
          isSyncContent: values.isSyncContent,
        },
        isLoading: true,
        showError: true,
      });

      if (!result?.id) {
        return;
      }

      formik.setValues(defaultInstitution);

      navigationTo(PATH.INSTITUTIONS);

      showToastMessage('success', 'Added Institution successfully!');
    },
  });

  const { values, isSubmitting, isValid, handleSubmit, handleChange, setFieldValue } = formik;

  const emailStatus = getInputStatus(
    values.email,
    SUCCESS_MESSAGE.EMAIL,
    isValidEmail(values.email.trim()).isValid ? '' : isValidEmail(values.email.trim()).message,
  );

  const disabled =
    hasEmptyValues({ name: values.name, email: values.email }) ||
    isSubmitting ||
    !isValid ||
    (values.email ? (isValidEmail(String(values?.email).trim()).isValid ? false : true) : false);

  const onChangeSwitch = () => {
    setFieldValue('isSyncContent', !values.isSyncContent);
  };

  const onCancel = () => {
    formik.setValues(defaultInstitution);
    navigationTo(`${PATH.INSTITUTIONS}`);
  };

  return {
    values,
    disabled,
    handleChange,
    handleSubmit,
    onChangeSwitch,
    onCancel,
    emailStatus,
  };
};
